import { createFeatureSelector, createSelector } from '@ngrx/store';

import { featureKey, ProjectState, State } from './combiner';

export const selectProjectState = createFeatureSelector<State, ProjectState>(featureKey);

export const selectPostProjectState = createSelector(selectProjectState, (state: ProjectState) => state.postProject);
export const selectPostComeroundProjectState = createSelector(
  selectProjectState,
  (state: ProjectState) => state.postComeroundProject
);
export const selectPutProjectState = createSelector(selectProjectState, (state: ProjectState) => state.putProject);
export const selectGetProjectByIdState = createSelector(
  selectProjectState,
  (state: ProjectState) => state.getProjectById
);
export const selectGetCoveragesState = createSelector(selectProjectState, (state: ProjectState) => state.getCoverages);
export const selectPutCoveragesState = createSelector(selectProjectState, (state: ProjectState) => state.putCoverages);
export const selectSimulationState = createSelector(selectProjectState, (state: ProjectState) => state.simulation);
